import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import Icon from '@ui/icons/icon';

interface SegmentedOption {
  value: string;
  label?: string;
  icon?: string;
  ariaLabel?: string;
}

interface SegmentedSwitchProps {
  value: string;
  options: SegmentedOption[];
  onChange: (value: string) => void;
  fullWidth?: boolean;
}

export default function SegmentedSwitch({ value, options, onChange, fullWidth }: SegmentedSwitchProps) {
  return (
    <Container
      className={`flex ai-center radius-100 padding-2 ${fullWidth ? 'width-100-percent' : 'flex-shrink-0'}`}
      background="var(--local-switch-bg)"
      width={fullWidth ? '100%' : 'fit-content'}
    >
      {options.map((option) => {
        const active = option.value === value;
        return (
          <Button
            key={option.value}
            clear
            className={`flex-1 ai-center jc-center ${fullWidth ? '' : 'flex-shrink-0'}`}
            height="28px"
            padding={option.icon ? '0' : '0 16px'}
            width={option.icon && !fullWidth ? '28px' : undefined}
            borderRadius="100px"
            backgroundColor={active ? 'var(--local-switch-active)' : 'transparent'}
            onClick={() => onChange(option.value)}
            aria-label={option.ariaLabel ?? option.label}
            title={option.ariaLabel ?? option.label}
          >
            {option.icon ? (
              <Icon
                name={option.icon}
                size={12}
                color={active ? 'var(--local-bttn-sec-default-icotext)' : 'var(--global-ico-text-3)'}
              />
            ) : (
              <Text
                className="L2"
                color={active ? 'var(--local-bttn-sec-default-icotext)' : 'var(--global-ico-text-3)'}
              >
                {option.label}
              </Text>
            )}
          </Button>
        );
      })}
    </Container>
  );
}
